export default function Footer() {
    return (
        <div style={{ borderTop: "1px solid lightgray", minWidth: "100vw", backgroundColor: "#fffaf1", display: "flex", justifyContent: "center", alignContent: "center" }}>
            <div className="mx-4" style={{ maxWidth: "1100px" }}>
                <div style={{ height: "10px" }}></div>
                <p> &copy; Zoe Lederman 2022</p>
            </div>
        </div >
    )
}
